(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeTaxDetailController', TypeTaxDetailController);

    TypeTaxDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TypeTax'];

    function TypeTaxDetailController($scope, $rootScope, $stateParams, entity, TypeTax) {
        var vm = this;
        vm.typeTax = entity;
        vm.load = function (id) {
            TypeTax.get({id: id}, function(result) {
                vm.typeTax = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:typeTaxUpdate', function(event, result) {
            vm.typeTax = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
